import React from 'react';

export default class ACHResultsTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sortAsc: true
        };
    }

    sortTable() {
        this.setState({ sortAsc: !this.state.sortAsc });
    }

    render() {
        const { achTransfers = [] } = this.props;

        return (
            <div className="table-container">
                <table className="table">
                    <thead>
                        <tr className="table-header table-row">
                            <th className="sort active">Application ID
                                <div className="sort-arrows relative" onClick={this.sortTable.bind(this)}>
                                    <i className="icon ion-android-arrow-dropup"></i>
                                    <i className="icon ion-android-arrow-dropdown"></i>
                                </div>
                            </th>
                            <th>Organization Name</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Error Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {achTransfers && achTransfers.slice().sort((a, b) => {
                            const aId = Number(a.applicationId) || 0;
                            const bId = Number(b.applicationId) || 0;
                            return this.state.sortAsc ? aId - bId : bId - aId;
                        }).map(transfer =>
                            <tr key={transfer.applicationId} className={`table-row ${transfer.success ? 'success' : 'error'}`}>
                                <td data-label="Application ID">
                                    <p className="bold-text">#{transfer.applicationId}</p>
                                </td>
                                <td data-label="Organization Name">
                                    <p>
                                        <strong>{transfer.orgName || 'N/A'}</strong>
                                    </p>
                                </td>
                                <td data-label="Amount">
                                    <p className="bold-text">${transfer.amount.toLocaleString()}</p>
                                </td>
                                <td data-label="Status">
                                    {transfer.success ? (
                                        <p>
                                            <i className="icon-check approved-text icon-left middle"></i>
                                            Success
                                        </p>
                                    ) : (
                                        <p>
                                            <i className="icon-close error-text icon-left middle"></i>
                                            Failed
                                        </p>
                                    )}
                                </td>
                                <td data-label="Error Message">
                                    {transfer.success ? (
                                        <span className="secondary-text">-</span>
                                    ) : (
                                        <span className="error-text">
                                            {transfer.errorMessage || 'Unknown error occurred'}
                                        </span>
                                    )}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {(!achTransfers || !achTransfers.length) && (
                    <div className="no-results">
                        <i className="icon ion-card"></i>
                        <span>No ACH Transfer Records</span>
                    </div>
                )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/achComponents/ACHResultsTable.jsx